import { DownOutlined, InfoCircleFilled, ReloadOutlined } from '@ant-design/icons';
import React, { useEffect, useMemo, useState } from 'react';
import './rubic.css';
import Loading from 'components/Loading';
import styled from 'styled-components';
import COLOR from 'utils/constants/color';
import {Dropdown} from 'antd';
import { MenuIcon } from "utils/assets/images";
import { get, map } from 'lodash';
import { Tooltip } from 'antd';


const UserAddignmentLabel = styled.span`
    font-size: 12px;
    font-weight: 400;
    line-height: 13px;
    // height: 40px;
    height: 26px;
    background: #e7edf2;
    padding: 10px;
    display: flex;
    align-items: center;
    // justify-content:space-between;
    justify-content:center;
    width:100%;
`;

const UserSelector = styled(UserAddignmentLabel)`
    font-weight: 400;
    line-height: 18px;
    height: 30px;
    background:${p =>p.user_not_active?"red": p.active ? 'rgb(14 70 183 / 87%)' : '#e7edf2'};
    color:${p => p.active || p.user_not_active ? '#e7edf2' : COLOR.black100};
    box-shadow:  ${p => p.active ? "0px 0px 0px 0px #958585e0, 0px 0px 5px 0px #958585e0" : "0px 0px #fff"};
    padding: 10px;
    display: flex;
    align-items: center;
    // margin: 10px;
    cursor: pointer;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    overflow-x: hidden;
    overflow-y: hidden;
    display: flex;
    height: 30px;
    // width: 96.5%;
    background:none;
`;
const CategoryMenu = styled.div`
    background-color:${COLOR.tabActive};
    border-radius: 0px 12px 12px 12px;
    color: #fff;
    height: 30px;
    padding-left: 20px;
    padding-right: 2px;
    margin-top: 4px;
    font-size: 13px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width:70%;
    align-items: center;
    cursor: pointer;

`;
const MenuIconImg = styled.img`
    margin-left:10px;
    height: 16px;
    background-color: #fff;
    border-radius: 50%;
    padding: 2px;
    margin-right: 10px;
`;
const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;
const NameText = styled.span`
    margin-right: 6px;
    width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const CreteriaGradeDesc = ({title , description , ai_grading })=>{
    const ai_feedback = ai_grading && Array.isArray(ai_grading) ? ai_grading.find(k=>k.criterionTitle === title|| k.criterionTitle === description) : null
    if(!ai_feedback) return null;
    return (<Tooltip title={ai_feedback.feedback} getPopupContainer={(trigger) => trigger.parentElement} >
        <InfoCircleFilled />
    </Tooltip>)
}

const GradebookRubric = ({currentSubmissionRubric, handleRubricUpdate = () => null , assignmentRubrics , loading, pastSubmissionRubric, rubricSection, allUserSubmissions, onStudentClick,type="", isMobileMenu=false, ai_grade_feedback }) => {
    const rubricMeta =  useMemo(()=>assignmentRubrics?assignmentRubrics.rubrics_meta:[],[assignmentRubrics]) ;
    const [selectStudent, setSelectStudent] = useState("All")
    const initialScores = rubricMeta.reduce((acc, criterion, index) => {
        acc[index] = null;
        return acc;
    }, {});
    const [scores, setScores] = useState(initialScores);
    const [rubricOpen, setRubricOpen] = useState(
        rubricMeta.reduce((acc, _, index) => {
            acc[index] = false;
            return acc;
        }, {})
    );
    const [showValidationMessage, setShowValidationMessage] = useState(false);
    const isStudentReviewSubmission = isMobileMenu && type === "studentReviewSubmission";
    const isAssignmentReviewSubmission = type === "assignmentReviewSubmission" && isMobileMenu;
    useEffect(() => {
        if (currentSubmissionRubric && Object.keys(currentSubmissionRubric).length > 0) {
            setScores(currentSubmissionRubric);
        } else {
            setScores(initialScores)
        }
    }, [currentSubmissionRubric]);
    const maxPoint = rubricMeta.reduce((sum, criterion) => sum + Math.max(...criterion.points.map(point => point.pointText)), 0);

    const handleScoreChange = (category, value) => {
        setScores({
            ...scores,
            [category]: value,
        });
    };

    const clearSelection = (category) => {
        setScores((prevScores) => ({
            ...prevScores,
            [category]: null,
        }));
    };

    const toggleRubricOpen = (index) => {
        setRubricOpen((prevOpen) => ({
            ...prevOpen,
            [index]: !prevOpen[index],
        }));
    };

    const calculateTotalScore = () => {
        const allSelected = Object.values(scores).every(score => score !== null);
        if (!allSelected) {
            setShowValidationMessage(true);
            return;
        }
        setShowValidationMessage(false);
        const total = Object.values(scores).reduce(
            (sum, score) => parseInt(sum) + (parseInt(score) || 0),
            0
        );
        handleRubricUpdate(scores, total)
    };


    const getUserName = (usrAssignments) => {
        const first_name = get(usrAssignments, "user.firstName", "");
        const last_name = get(usrAssignments, "user.lastName", "");
        return <NameText>{first_name} {last_name}</NameText>
    }

    const filterStudentList = (key) => {
        const user = key?.user
        setSelectStudent(`${user?.firstName} ${user?.lastName}`)
        onStudentClick(key)
    }

    const categoryNav = useMemo(() => {
        return {
            items: map(allUserSubmissions, (ct) => ({
                key: ct.id || ct.user?.id,
                label: (
                    <PaddedBtn
                        onClick={() => {
                            filterStudentList(ct);
                        }}
                    >
                        {getUserName(ct)}
                    </PaddedBtn>
                ),
                style: { padding: "0px" }
            })),
            onClick: () => {} // Empty onClick since we handle clicks in the PaddedBtn
        };
    }, [allUserSubmissions, filterStudentList, getUserName]);

    return (
        <div className={rubricSection ? "viewAssignmentRubric" : `rubric-container ${isStudentReviewSubmission ? "rubric-student-review mt-0px" : "" } ${isAssignmentReviewSubmission ? "mt-0px rubric-student-review" : ""}`}>
            <div className="rubricHeader">
                <h2>Rubric</h2>
                {rubricSection && (
                <UserSelector style={{ height: "auto", marginTop: 0, display:"flex", alignItems:"center", justifyContent:"center" }}>
                        {/* <strong style={{ minWidth: 60 }}>Filter Student</strong> */}
                        <Dropdown menu={categoryNav} placement="bottomLeft" trigger={['click']} getPopupContainer={trigger => trigger.parentNode}>
                            <CategoryMenu>{selectStudent}<MenuIconImg src={MenuIcon} /> </CategoryMenu>
                        </Dropdown>
                </UserSelector>
                )}
                <div style={{display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center"}}>
                    <button 
                        className="updateRubric" 
                        onClick={calculateTotalScore}
                        disabled={loading}
                        style={{ display:"flex"}}
                    >
                       {loading?<Loading size={14} white />:null} Update
                    </button>
                    {/* <span className="score">
                        {Object.values(scores).reduce((sum, score) => parseInt(sum) + (parseInt(score) || 0), 0)}/{maxPoint}
                    </span> */}
                </div>
                <span className="score">
                    {Object.values(scores).reduce((sum, score) => parseInt(sum) + (parseInt(score) || 0), 0)}/{maxPoint}
                </span>
            </div>
            {showValidationMessage && (
                <div className="rubricValMessage" style={{marginTop:"0px", textAlign:"center"}}>
                    <p>Please select one rubric item from each.</p>
                </div>
            )}
            {rubricMeta.map((criterion, index) => (
                <div key={index} className="rubric-section">
                    <div className="allClrSection">
                        <h4>{criterion.criterionTitle} <CreteriaGradeDesc title={criterion.criterionTitle} description={criterion.criterionDescription} ai_grading={ai_grade_feedback} /></h4>
                        <div className="assignmentPoints">
                            <button className="clear-btn" onClick={() => clearSelection(index)}>
                                <ReloadOutlined
                                    style={{ color: 'rgb(14 70 183 / 87%)', fontSize: '12px', marginRight: '10px' }}
                                />
                                Clear
                            </button>
                            <p>
                                {scores[index] !== null
                                    ? `${scores[index]}/${Math.max(...criterion.points.map((point) => point.pointText))}`
                                    : `/${Math.max(...criterion.points.map((point) => point.pointText))}`}
                            </p>
                            <div className="rubricContainer" onClick={() => toggleRubricOpen(index)}>
                                <div
                                    style={{
                                        transition: 'transform 0.4s ease-in-out',
                                        transform: rubricOpen[index] ? 'rotate(-180deg)' : 'rotate(0deg)',
                                    }}
                                >
                                    <DownOutlined style={{ color: 'rgb(14 70 183 / 87%)' }} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {!rubricOpen[index] ? (
                        <div>
                            <p>{criterion.criterionDescription}</p>
                            <div className="rubric-items">
                                {criterion.points.map((point, pointIndex) => (
                                    <div
                                        key={pointIndex}
                                        className={`rubric-item ${scores[index] === point.pointText ? 'selected' : ''}`}
                                        onClick={() => handleScoreChange(index, point.pointText)}
                                    >
                                        <div className="allRubricPoint">
                                            <div className="rubricPoint">
                                                {point.title}
                                                <span>{point.pointText} pts</span>
                                            </div>
                                            <p style={{ fontSize: "13px" }}>{point.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="rubric-items">
                            {criterion.points.map((point, pointIndex) => (
                                <div
                                    key={pointIndex}
                                    className={`rubricNewSection ${scores[index] === point.pointText ? 'selected' : ''}`}
                                    onClick={() => handleScoreChange(index, point.pointText)}
                                ><span>{point.pointText} pts</span></div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}

export default GradebookRubric;

